import React, { useEffect, useState } from "react"
import "./assignTask.scss"

import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Spinner,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import * as Yup from "yup"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import { InputNumber } from "primereact/inputnumber"
import { useNavigate } from "react-router-dom"

import TaskApi from "Api/TaskApi"

const AssignTask = () => {
  document.title = "Assign Task"
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const taskInitialData = {
    taskName: "",
    taskCategory: null,
    target: "",
    startDate: null,
    dueDate: null,
    priority: null,
    assignTo: null,
    remarks: "",
  }

  const [taskData, setTaskData] = useState(taskInitialData)

  const [errors, setErrors] = useState({})
  const [analystMenu, setAnalystMenu] = useState([])
  const [startDate, setStartDate] = useState(null)
  // const handleTaskChange = (name, value) => {
  //   setTaskData(prevData => ({ ...prevData, [name]: value }))
  //   // setTaskData({ ...taskData, [name]: value });
  //   setErrors({ ...errors, [name]: "" })
  //   console.log("check calender")
  // }
  const handleTaskChange = (name, value) => {
    setTaskData(prevData => {
      const newData = { ...prevData }

    //   if (name === 'startDate') {
    //     newData.startDate = value;
    //     // Reset dueDate if it's before the new startDate
    //     if (newData.dueDate && value && newData.dueDate < value) {
    //       newData.dueDate = null
    //     }
    //   } else if (name === 'dueDate') {
    //     newData.dueDate = value
    //   } else {
    //     newData[name] = value
    //   }

    //   return newData;
    // })
    })

    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: ""
    }))
  }

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Task", link: "#" },
    { label: "Assign Task", link: "#" },
  ]

  const taskCategoryOptions = [
    { name: "University", code: "University" },
    { name: "Institution", code: "Institution" },
    { name: "Program", code: "Program" },
    { name: "Course", code: "Course" },
  ]

  const priorityOptions = [
    { name: "High", code: "High" },
    { name: "Medium", code: "Medium" },
    { name: "Low", code: "Low" },
  ]

  
  const getAnalystDropdown = () => {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    TaskApi.getAnalystUser(config)
      .then(res => {
        const formattedData = res.data.users.map(user => ({
          name: user.userName,
          code: user._id,
        }))
        setAnalystMenu(formattedData)
      })
      .catch(error => {
        console.error("Error fetching analysts:", error)
      })
  }

  useEffect(() => {
    getAnalystDropdown()
  }, [accessToken])

  const validateForm = () => {
    const newErrors = {}
    if (!taskData.taskName?.trim()) newErrors.taskName = "Task name is required"
    if (!taskData.taskCategory) newErrors.taskCategory = "Task category is required"
    if (!taskData.target?.trim()) newErrors.target = "Target is required"
    if (!taskData.startDate) newErrors.startDate = "Start date is required"
    if (!taskData.dueDate) newErrors.dueDate = "Due date is required"
    if (!taskData.priority) newErrors.priority = "Priority is required"
    if (!taskData.assignTo) newErrors.assignTo = "Assignee is required"

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const assignTask = () => {

    if (!validateForm()) return;
    const payload = {
      ...taskData,
      taskCategory: taskData.taskCategory.name.toLowerCase(),
      priority: taskData.priority.name.toLowerCase(),
      assignTo: taskData.assignTo.code,
    //  startDate: taskData.startDate ? new Date(taskData.startDate).toISOString() : null,
      // dueDate: taskData.dueDate ? new Date(taskData.dueDate).toISOString() : null,
      startDate:taskData.startDate,
      dueDate:taskData.dueDate,
    }

    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    }

    setLoading(true)
    TaskApi.assignTask(payload, config)
      .then(res => {
        if (res.data.status) {
          setLoading(false)
          navigate("/taskList")
        }
      })
      .catch(error => {
        setLoading(false)
        console.log(error)
      })
  }
  

  return (
    <div className="assign-Task">
      <Row>
        <Col xs="12">
          <div className="task-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Assign Task" />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="task-add-form ">
                <div className="task-add-inp">
                  <label htmlFor="taskName" className="label">
                    Task Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="taskName"
                      value={taskData.taskName}
                      onChange={e =>
                        handleTaskChange("taskName", e.target.value)
                      }
                      placeholder="Enter Task Name"
                      className="inp-field-box"
                    />
                    {errors.taskName && (
                      <small className="error">{errors.taskName}</small>
                    )}
                  </div>
                </div>

                <div className="task-add-inp">
                  <label htmlFor="taskCategory">TaskCategory</label>
                  <div className="inp-err">
                    <Dropdown
                      id="taskCategory"
                      value={taskData.taskCategory}
                      onChange={e => handleTaskChange("taskCategory", e.value)}
                      optionLabel="name"
                      options={taskCategoryOptions}
                      placeholder="Select Task Category"
                    />
                    {errors.taskCategory && (
                      <small className="error">{errors.taskCategory}</small>
                    )}
                  </div>
                </div>

                <div className="task-add-inp">
                  <label htmlFor="target" className="label">
                    Target
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="target"
                      value={taskData.target}
                      onChange={e => handleTaskChange("target", e.target.value)}
                      placeholder="Enter Target"
                      className="inp-field-box"
                    />
                    {errors.target && (
                      <small className="error">{errors.target}</small>
                    )}
                  </div>
                </div>
                <div className="task-add-inp">
                  <label htmlFor="startDate" className="label">
                    Start Date
                  </label>
                  <div className="inp-err">

                  <InputText
                      id="startDate"
                      value={taskData.startDate}
                      onChange={e => handleTaskChange("startDate", e.target.value)}
                      placeholder="Enter startDate"
                      className="inp-field-box"
                    />

                    {/* <Calendar
                      id="startDate"
                      value={taskData.startDate}
                      onChange={(e) => handleTaskChange("startDate", e.value)}
                      dateFormat="dd/mm/yy"
                      showIcon
                      placeholder="Select Start Date"
                      className="w-100"
                      minDate={new Date()}
                      showTime={false}
                    /> */}
                    {errors.startDate && (
                      <small className="error">{errors.startDate}</small>
                    )}
                  </div>
                </div>

                <div className="task-add-inp">
                  <label htmlFor="dueDate" className="label">
                    Due Date
                  </label>
                  <div className="inp-err">

                  <InputText
                      id="dueDate"
                      value={taskData.dueDate}
                      onChange={e => handleTaskChange("dueDate", e.target.value)}
                      placeholder="Enter DueDate"
                      className="inp-field-box"
                    />
                    {/* <Calendar
                      id="dueDate"
                      value={taskData.dueDate}
                      onChange={e => handleTaskChange("dueDate", e.value)}
                      dateFormat="dd/mm/yy"
                      showIcon
                      placeholder="Select Due Date"
                      className="w-100"
                      minDate={taskData.startDate || new Date()}
                      showTime={false}

                      disabled={!taskData.startDate}
                    /> */}
                    {errors.dueDate && (
                      <small className="error">{errors.dueDate}</small>
                    )}
                  </div>
                </div>


                <div className="task-add-inp">
                  <label htmlFor="priority">Priority</label>
                  <div className="inp-err">
                    <Dropdown
                      id="priority"
                      value={taskData.priority}
                      onChange={e => handleTaskChange("priority", e.value)}
                      optionLabel="name"
                      options={priorityOptions}
                      placeholder="Select Priority"
                    />
                    {errors.priority && (
                      <small className="error">{errors.priority}</small>
                    )}
                  </div>
                </div>

                <div className="task-add-inp">
                  <label htmlFor="assignTo">AssignTo</label>
                  <div className="inp-err">
                    <Dropdown
                      id="assignTo"
                      value={taskData.assignTo}
                      onChange={e => handleTaskChange("assignTo", e.value)}
                      optionLabel="name"
                      options={analystMenu}
                      placeholder="Select Analyst"
                    />
                    {errors.assignTo && (
                      <small className="error">{errors.assignTo}</small>
                    )}
                  </div>
                </div>

                <div className="task-add-inp">
                  <label htmlFor="remarks" className="label">
                    Remarks
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="remarks"
                      value={taskData.remarks}
                      onChange={e =>
                        handleTaskChange("remarks", e.target.value)
                      }
                      placeholder="Enter Remarks"
                      className="inp-field-box"
                    />
                    {errors.remarks && (
                      <small className="error">{errors.remarks}</small>
                    )}
                  </div>
                </div>
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  onClick={() => {
                    assignTask()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Add"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default AssignTask
